import { SelectField } from '@dispatch/web/ui';
import { Grid } from '@mui/material';
import { Control, FieldErrors, FieldValues } from 'react-hook-form';

export const ClaimAttributesSection = ({
  control,
  errors,
  attributeOptions,
}: {
  errors: FieldErrors;
  control: Control<FieldValues>;
  attributeOptions?: { title: string; value: string }[];
}) => {
  return (
    <Grid container>
      <Grid container spacing={2} marginBottom={2} data-testid="attributes">
        <Grid size={12}>
          <SelectField
            multiple
            id="attributes"
            name="attributes"
            label="Attributes"
            required
            control={control}
            errors={errors}
            options={attributeOptions || []}
            disabled
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
